import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.google-marketplace-instructions', {
        url: '/googleMarketPlaceInstructions',
        component: 'companyGoogleMarketplaceInstructions',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-instructions/google-marketplace-instructions.state.js